import * as yup from 'yup';

import { issues, IssuesKeys } from './components';

export const commentInput: Record<IssuesKeys, { label: string; placeholder: string } | null> = {
  not_transferred_amount: {
    label: 'Укажите сумму, которую вы перевели',
    placeholder: 'Введите сумму',
  },
  multiple_transfers: null,
  not_transferred_bank: {
    label: 'Укажите банк, в который вы совершили перевод',
    placeholder: 'Введите банк',
  },
  other: {
    label: 'Опишите проблему',
    placeholder: 'Опишите проблему',
  },
};

export const titles: Record<IssuesKeys, string> = {
  not_transferred_amount: issues.not_transferred_amount,
  multiple_transfers: issues.multiple_transfers,
  not_transferred_bank: issues.not_transferred_bank,
  other: 'Опишите проблему',
};

const MAX_COMMENT_LENGTH = 500;

export const schema = yup.object().shape({
  selectedIssue: yup.string<IssuesKeys>().nullable().defined(),
  comment: yup
    .string()
    .default('')
    .optional()
    .max(
      MAX_COMMENT_LENGTH,
      `Превышен лимит: комментарий может содержать максимум ${MAX_COMMENT_LENGTH} символов.`,
    ),
  files: yup
    .array()
    .of(yup.mixed<File>().required())
    .required('Список файлов не должен быть пустым.')
    .min(1, 'Список файлов не должен быть пустым.'),
});
